import { Injectable, ErrorHandler, Inject } from '@angular/core';
import { AlertsService, IAlertTypes } from '@tablesready/frontend-alerts-bar';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  constructor(
    @Inject('LOG_ERRORS') readonly isLoggingEnabled: boolean,
    private readonly alertService: AlertsService,
  ) {
    super();
  }

  handleError(error: any): void {
    if (this.isLoggingEnabled) {
      console.log(error);
    }

    const isErrorMessage = error?.error?.message !== undefined;
    const isErrorError = error?.error?.error !== undefined;
    const isHttpError = error?.name === 'HttpErrorResponse';

    if (isHttpError && error.status === 0) {
      console.log('Network connection lost. Please check your internet connection.');
      this.alertService.add({
        id: 'network-connection-lost',
        duration: 7 * 24 * 60 * 60 * 1000, // 7 days
        time: Date.now(),
        type: IAlertTypes.danger,
        heading: 'Oops.',
        body: 'It looks like there\'s a problem with your connection',
        actions: [
          {
            label: 'Click here to reload',
            action: (): void => {
              window.location.reload();
            },
          },
        ],
      });
    } else if (isErrorMessage) {
      this.alertService.addError(String(error.error.message));
    } else if (isErrorError) {
      this.alertService.addError(String(error.error.error));
    } else {
      super.handleError(error);
    }
  }
}
